import {
    Column
} from 'devextreme-react/data-grid';

import { useSearchOrders } from "../api/search-orders";
import { OrderSearchGridProps } from '../types/OrderSearchGridProps';
import { OrderSearchParams } from '../types/OrderSearchParams';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { CompanyTypes, MOType } from '../../../../types/enums';
import { useAuth } from '../../../../contexts/auth';

export default function OrderSearchGrid(props: OrderSearchGridProps) {

    let params = {} as OrderSearchParams;
    params[props.searchField as keyof OrderSearchParams] = props.searchText;

    const orders = useSearchOrders(params);

    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    const creditMemoMOTypes = [MOType.Material, MOType.Sink, MOType.Stocking]

    const { user } = useAuth();
    const isManufacturer = user?.companyTypeId === CompanyTypes.MFR;
    const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;
    const urlFolder = isManufacturer ? "manufacturer" : isServiceProvider ? "service-provider" : "distributor";

    return (
        <>
            <SyncDataGrid
                stateStorageKey={urlFolder + '-purchase-order-search-grid'}
                className={'dx-card wide-card'}
                dataSource={orders.data}
                keyExpr={'purchaseOrderID'}
                height="68vh"
            >
                <Column
                    dataField={'poNumber'}
                    caption={'Purchase Order #'}
                    dataType="string"
                    cellRender={(row: any) => {
                        return <Link to={`/${urlFolder}/purchase-order/${row.data.purchaseOrderID}?returnUrl=${returnUrl}`}>
                            {row.data.poNumber}
                        </Link>;
                    }}
                />
                <Column
                    dataField={'moNumber'}
                    caption={'Material Order #'}
                    dataType="string"
                />
                <Column
                    dataField={'roNumber'}
                    caption={'Retail Order #'}
                    dataType="string"
                />
                <Column
                    dataField={'createdOn'}
                    caption={'Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'roDate'}
                    caption={'Retail Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'cfiName'}
                    caption={'CFI Name'}
                    dataType="string"
                />
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'shipTo'}
                        caption={'Ship To'}
                        dataType="string"
                    />
                }
                <Column
                    dataField={'orderStatus'}
                    caption={'Order Status'}
                    dataType="string"
                />
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'requestedShipDate'}
                        caption={'Requested Ship Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'validatedShipDate'}
                        caption={'Validated Ship Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'actualShipDate'}
                        caption={'Actual Ship Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'requestedDeliveryDate'}
                        caption={'Requested Delivery Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'validatedDeliveryDate'}
                        caption={'Validated Delivery Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'deliveredDate'}
                        caption={'Delivered Date'}
                        dataType="date"
                    />
                }
                {
                    isServiceProvider &&
                    <Column
                        dataField={'serviceInitiatedDate'}
                        caption={'Service Initiated Date'}
                        dataType="date"
                    />
                }
                {
                    !isServiceProvider &&
                    <Column
                        dataField={'distributorName'}
                        caption={'Distributor'}
                        dataType="string"
                        visible={isManufacturer}
                    />
                }
                <Column
                    dataField={'creditMemo'}
                    caption={'Credit Memo'}
                    allowExporting={false}
                    dataType="string"
                    cellRender={(row: any) => {

                        if (row.data.actualShipDate && (creditMemoMOTypes.includes(row.data.moTypeID))) {
                            return <Link to={`/${urlFolder}/credit-memo/${row.data.purchaseOrderID}/new?returnUrl=${returnUrl}`}>
                                Credit Memo
                            </Link>;
                        }
                        else {
                            return <></>
                        }
                    }}
                />
            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />
        </>
    )
} 
